module.exports = __webpack_public_path__ + "img/2012-08-18 12.56.35.fc1e1ed4.jpg";